import { RemoveClientForExpertModal } from './RemoveClientForExpertModal'

export default RemoveClientForExpertModal;